var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h2',[_vm._v("Server Error")]),_c('div',[_vm._v(_vm._s(_vm.$route.params.mesg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }